var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4853 -0.220581C72.7205 -0.220581 75.956 -0.220581 79.1912 -0.220581C108.85 2.7496 130.247 17.6026 143.382 44.3382C146.836 52.4427 148.969 60.825 149.779 69.4853C149.779 73.0147 149.779 76.5441 149.779 80.0735C147.202 105.162 135.438 124.647 114.485 138.529C103.811 144.871 92.34 148.621 80.0735 149.779C76.5441 149.779 73.0147 149.779 69.4853 149.779C45.0715 147.244 25.8803 135.92 11.9118 115.809C4.80504 104.562 0.760935 92.3568 -0.220581 79.1912C-0.220581 75.956 -0.220581 72.7205 -0.220581 69.4853C0.245015 64.7819 1.05384 60.0759 2.20589 55.3677C12.8856 22.5506 35.3121 4.02118 69.4853 -0.220581Z",
    fill: "#D3D0E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6027 36.3972C86.9521 34.8425 99.6725 42.4896 106.764 59.3384C110.891 76.081 105.817 89.2426 91.5439 98.8237C73.3806 107.206 58.3069 103.456 46.3233 87.5737C37.3051 69.7572 40.4669 54.5366 55.8086 41.9119C59.8409 39.4199 64.1053 37.5817 68.6027 36.3972Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8672 110.956C66.4138 110.747 84.9432 110.968 103.455 111.617C112.271 113.667 119.035 118.52 123.75 126.176C115.826 134.483 106.267 140.218 95.0731 143.382C71.7366 149.883 50.4132 145.912 31.1025 131.47C28.9782 129.861 27.0664 128.023 25.3672 125.956C30.7624 117.761 38.2624 112.761 47.8672 110.956Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImg);
export default __webpack_public_path__ + "static/media/emptyImg.36846526be327978598d8624d8dc4931.svg";
export { ForwardRef as ReactComponent };